import { render, staticRenderFns } from "./GestionMx.vue?vue&type=template&id=760b3899&scoped=true"
import script from "./GestionMx.vue?vue&type=script&lang=js"
export * from "./GestionMx.vue?vue&type=script&lang=js"
import style0 from "./GestionMx.vue?vue&type=style&index=0&id=760b3899&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760b3899",
  null
  
)

export default component.exports